
import { Component, Vue } from "vue-property-decorator";
import router from "@/router";
import SchedulePicker from "@/components/SchedulePicker.vue";
import RelayInfo from "@/components/relays/RelayInfo.vue";
import RelayGraphKey from "@/components/relays/RelayGraphKey.vue";
import LogTable from "@/components/logs/LogTable.vue";
import RelayStatus from "@/components/relays/RelayStatus.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiAlert } from "@mdi/js";

@Component({
  components: {
    RelayStatus,
    LogTable,
    RelayInfo,
    RelayGraphKey,
    SchedulePicker,
    SvgIcon,
  },
})
export default class Relay extends Vue {
  private relay: any = null;
  private loading: boolean = false;
  private subTab: string = null;
  private countAlert: number = 0;
  private mdiAlert = mdiAlert;

  private mounted() {
    this.reset();
  }

  private reset() {
    const relayId = Number(this.$route.params.id);
    if (relayId) {
      this.getRelay(relayId);
      this.getAlertKeys(relayId);
    }
  }

  private getAlertKeys(relayId: number) {
    return this.$store.dispatch("relays/getAlertKeys", {
      relayId,
    }).then((res) => {
      this.countAlert = res ? res.length : 0;
    });
  }

  private getRelay(id: number) {
    this.loading = true;
    this.$store.dispatch("relays/getById", { id }).then(async (relay) => {
      // Update global env companyId with current entity company
      await this.$store.dispatch("changeEnvCompanyId", relay.companyId);
      this.relay = relay;
    })
      .catch(() => router.push({ name: "home" }))
      .finally(() => {
        this.loading = false;
      });
  }

}
